import { EmailAccount } from '../../accounts/email-accounts/email-account.model';
import { FacebookAccount } from '../../accounts/facebook-accounts/facebook-account.model';
import { GoogleAccount } from '../../accounts/google-accounts/google-account.model';
import { PaypalAccount } from '../../accounts/paypal-accounts/paypal-account.model';
import { MailchimpAccount } from '../../accounts/mailchimp-accounts/mailchimp-account.model';
import { SmsAccount } from '../../accounts/sms-accounts/sms-account.model';
import { TwitterAccount } from '../../accounts/twitter-accounts/twitter-account.model';
import { Location } from '../../location-setup/location.model';
import {Region} from '../../regions/region.model';
import {WiredMessengerAccount} from '../../accounts/wired-messenger-accounts/wired-messenger-account.model';

export class CaptivePortal {
  active;
  allowEmailLogin = false;
  allowLoyaltyLogin = false;
  allowMacAddressLogin = false;
  allowMacForgetting = false;
  allowPaypalLogin = false;
  allowSms = false;
  allowFacebookLogin = false;
  allowTwitterLogin = false;
  allowGoogleLogin = false;
  allowTermsConditionsLogin = false;
  allowVoucherLogin = false;
  captivePortalCode;
  clientId;
  clients;
  cpLocaleCode;
  cpTemplate: {
    id: null;
    clientId: null;
    name: null;
    updateTime: null;
    views: null;
  };
  regions: Region;
  cpTitle;
  dailyRate;
  defaultLanguageCode;
  description;
  deviceLimit;
  emailAccount: EmailAccount;
  emailAddressLimitExpiryDays;
  emailAddressLimitForDevice;
  emailUsePassword = false;
  emailVerifyBody;
  emailVerifyTitle;
  facebookAccount: FacebookAccount;
  googleAccount: GoogleAccount;
  hourlyRate;
  id;
  loginCompleteUrl;
  mailchimpAccount: MailchimpAccount;
  mailchimpList;
  mailchimpListId;
  mailchimpListName;
  mailchimpGroup;
  mailchimpGroupId;
  mailchimpGroupCategory;
  mailchimpGroupCategoryId;
  nasid;
  not_verifiedSessionsLimit;
  paypalAccount: PaypalAccount;
  redirectOption;
  forbidMultyEmails = false;
  sendEmailAfterLogin;
  sendEmailAfterLoginText;
  sendEmailAfterLoginTitle;
  smsAccount: SmsAccount;
  smsMessage;
  surfilterUrl;
  templateId;
  twitterAccount: TwitterAccount;
  urlFacebook;
  urlGoogle;
  urlInstagram;
  urlPinterest;
  urlTwitter;
  urlVine;
  urlYoutube;
  useMailchimp = false;
  useWiredmessenger = false;
  useTemplate = false;
  venues: Location;
  verifyEmail;
  verifyTimeMinutes;
  weeklyRate;
  useRedirectStrategy = false;
  redirectStrategy;
  redirectSendParams = false;
  redirectNasidParam = 'nasid';
  redirectMacAddressParam = 'user_mac';
  useMessagingStrategy = false;
  messagingStrategy;
  wiredMessengerAccount: WiredMessengerAccount;
  wiredmessengerTemplateId;
  wiredmessengerListId;
  wiredmessengerCampaignName;
  wiredmessengerCustomStoreNumber;
  wiredmessengerCustomStoreAddress;
  wiredmessengerCustomStoreCity;
  wiredmessengerCustomStoreName;
  optInFullName;
  optInPhoneNumber;
  optInLoyaltyCardNumber;
  optInEmail;
  optInRequired;
  additionalFirstName;
  askAboutForgetMac = false;
  blockedCPText;
  autoSetOptIn = false;

  constructor(obj?: CaptivePortal) {
    for (const prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        this[prop] = obj[prop];
      }
    }
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/organization/captive-portal/cp-add-update/cp.model.ts